import React from 'react';
import NotLoggedBaseScreen from '../../components/NotLoggedBaseScreen';
import { Wrapper } from './NotFoundScreen.styles';
import { useBaseScreenHook } from '../../logic/core/base-screen.hook';

const NotFoundScreen: React.FC = () => {
    const { t, navigate } = useBaseScreenHook();

    return (
        <NotLoggedBaseScreen>
            <Wrapper>
                <h2 className="title">{t('notFound.title')}</h2>
                <p className="description">
                    {t('notFound.description')}
                </p>
                <button className="button" onClick={() => navigate('/')}>
                    {t('notFound.backHome')}
                </button>
            </Wrapper>
        </NotLoggedBaseScreen>
    );
};

export default NotFoundScreen;
